export const FirebaseConfig = {
    apiKey: "AIzaSyBQdGXlFwV3qIVXn3zQRKJfObbgs0C09xk",
    authDomain: "buji-6fda9.firebaseapp.com",
    projectId: "buji-6fda9",
    storageBucket: "buji-6fda9.firebasestorage.app",
    messagingSenderId: "846045724949",
    appId: "1:846045724949:web:8946b57a0895f81c85e91c",
    measurementId: "G-NNYG2ZH455", // NOTE: For Firebase JS SDK v7.20.0 and later, measurementId is automatically fetch and thus optional. However, it does serve as a fallback in the rare case that the dynamic fetch fails.
};